import { COUNSELOR_VIEW, STUDENT_VIEW } from '../../redux/app';
import SPARTAN_USER_TYPES from '../../../constants/spartan-user-types';
import SITE_MODES from '../../../constants/site-modes';
import getUserTitleByTerms from '../../utils/getUserTitleByTerms';
import getAdvisorTitleByTerms from '../../utils/getAdvisorTitleByTerms';

export const getLinksForNavbar = ({
  authLevel,
  companyDomain,
  connectMode,
  customPrograms,
  intake,
  jobBoard,
  me,
  siteMode,
  view,
  terms,
  showMyJourney,
}) => {
  const links = [];

  if (intake && authLevel === 5) {
    links.push({
      id: 'welcome',
      path: '/welcome',
      name: 'Pre-Assessment Survey',
      isExact: false,
    });

    // early exit in case of intake
    return links;
  }

  if (view === STUDENT_VIEW && showMyJourney) {
    links.push({
      id: 'journey',
      path: '/journey',
      name: 'My Journey',
      isExact: false,
    });
  }
  if (view === COUNSELOR_VIEW) {
    links.push({
      id: 'home',
      path: '/',
      name: `${getUserTitleByTerms(terms)}s`,
      isExact: true,
    });
  } else {
    links.push({
      id: 'assessment',
      path: '/results',
      name: 'Assessments',
      isExact: false,
      childRoutes: ['/assessment'],
    });
    // links.push(
    //   <li key="assessment">
    //     <Route
    //       path="/:page(results|assessment)?"
    //       component={({
    //         match: {
    //           params: { page },
    //         },
    //       }) => (
    //         <Link
    //           to="/results"
    //           active={!!page}
    //           onClick={() => setActive(false)}
    //         >
    //                         Assessments
    //         </Link>
    //       )}
    //     />
    //   </li>,
    // );
    if (customPrograms) {
      links.push({
        id: 'programs-matches',
        path: '/program-matches',
        name: 'Programs',
        isExact: false,
      });
    }
  }
  if (
    view === STUDENT_VIEW &&
    connectMode &&
    companyDomain !== 'petersons' &&
    companyDomain !== 'nustaredu' &&
    me.spartanUserType !== SPARTAN_USER_TYPES.ON_CAMPUS_VISIT
  ) {
    links.push({
      id: 'colleges',
      path: '/colleges',
      name: 'Colleges',
      isExact: false,
    });
  }
  if (view === STUDENT_VIEW && siteMode !== SITE_MODES.EMPLOYER) {
    links.push({
      id: 'career-matches',
      path: '/career-matches',
      name: 'Careers',
      isExact: false,
      childRoutes: ['/career-details'],
    });
  }
  if (view === STUDENT_VIEW && jobBoard) {
    links.push({
      id: 'jobs',
      path: '/jobs',
      name: 'Jobs',
      isExact: false,
    });
  }
  if (view === COUNSELOR_VIEW && siteMode === SITE_MODES.EMPLOYER) {
    links.push({
      id: 'employees',
      path: '/employees',
      name: 'Employees',
      isExact: false,
    });
  }

  if (view === COUNSELOR_VIEW && siteMode !== SITE_MODES.EMPLOYER) {
    links.push({
      id: 'resources',
      path: '/resources',
      name: 'Resources',
      isExact: false,
    });
  } else {
    links.push({
      id: 'tools',
      path: '/tools',
      name: 'Tools',
      isExact: false,
    });
  }

  return links;
};

export const getLinksForRightMenu = ({
  me,
  view,
  siteMode,
  intake,
  customPrograms,
  authLevel,
  terms,
  showMyJourney,
  demographicQuestions,
}) => {
  const links = [];

  if (!me) return links;

  if (
    view === STUDENT_VIEW &&
    siteMode !== SITE_MODES.EMPLOYER &&
    !intake &&
    customPrograms
  ) {
    links.push({
      id: 'program-matches',
      path: '/program-matches',
      name: 'Programs',
      isExact: false,
    });
  }

  if (authLevel && authLevel <= 3) {
    links.push({
      id: 'change-view',
      path: '/change-view',
      name: view === COUNSELOR_VIEW
        ? `${getUserTitleByTerms(
          terms,
        )} View`
        : `${getAdvisorTitleByTerms(
          terms,
        )} View`,
      isExact: false,
    });
  }

  if (view === COUNSELOR_VIEW && authLevel && authLevel <= 2) {
    links.push({
      id: 'sites',
      path: '/sites',
      name: 'Manage Sites',
      isExact: false,
    });
    links.push({
      id: 'users',
      path: '/users',
      name: 'Manage Users',
      isExact: false,
    });
  }

  if (view === COUNSELOR_VIEW && authLevel && authLevel <= 2 && customPrograms) {
    links.push({
      id: 'programs-and-schools',
      path: '/programs-and-schools',
      name: 'Manage Programs & Schools',
      isExact: false,
    });
  }

  if (view === COUNSELOR_VIEW && authLevel && authLevel === 1 && !customPrograms) {
    links.push({
      id: 'manage-programs',
      path: '/manage-programs',
      name: 'Manage Programs',
      isExact: false,
    });
  }

  if (authLevel && authLevel <= 2 && showMyJourney) {
    links.push({
      id: 'manage-journey',
      path: '/manage-journey',
      name: 'My Journey',
      isExact: false,
    });
  }

  if (view !== COUNSELOR_VIEW && demographicQuestions && !intake) {
    links.push({
      id: 'profile',
      path: '/profile',
      name: 'PathwayU Profile',
      isExact: false,
    });
  }

  if (!(intake && authLevel === 5)) {
    links.push({
      id: 'account',
      path: '/account',
      name: 'PathwayU Account Settings',
      isExact: false,
    });
  }

  links.push({
    id: 'logout',
    path: '/logout',
    name: 'Log Out',
    isExact: false,
  });

  return links;
};



// WEBPACK FOOTER //
// ./src/client/Components/Navigation/utils.js